// extracted by mini-css-extract-plugin
module.exports = {"root":"pageTitleSection_root__X2AXh","wrapper":"pageTitleSection_wrapper__1GExC","title":"pageTitleSection_title__kq9wE","backgroundImg":"pageTitleSection_backgroundImg__1sksX"};